'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [meetingCode, setMeetingCode] = useState('');

  const handleNewMeeting = () => {
    router.push(`/rooms/${generateRoomId()}`);
  };

  const handleJoinMeeting = (e: React.FormEvent) => {
    e.preventDefault();
    if (meetingCode.trim()) {
      router.push(`/rooms/${meetingCode.trim()}`);
    }
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className={styles.landingContainer}>
        <div className={styles.logo}>
          <h1>MStar Meet</h1>
        </div>
        
        <div className={styles.actions}>
          <button className={styles.newMeetingButton} onClick={handleNewMeeting}>
            New meeting
          </button>
          
          <div className={styles.divider}>
            <span>OR</span>
          </div>
          
          <form onSubmit={handleJoinMeeting} className={styles.joinForm}>
            <input
              type="text"
              placeholder="Enter a meeting code"
              value={meetingCode}
              onChange={(e) => setMeetingCode(e.target.value)}
              className={styles.meetingInput}
            />
            <button type="submit" className={styles.joinButton} disabled={!meetingCode.trim()}>
              Join
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
